import type { App } from "vue";
import trackDirective from "@/directives/track";
import testDirective from "@/directives/test";
import BaseTextField from "@/components/formfields/BaseTextField.vue";
import BaseSelect from "@/components/formfields/BaseSelect.vue";
import BaseAutoComplete from "@/components/formfields/BaseAutoComplete.vue";
import CharacterLimitedTextField from "@/components/formfields/CharacterLimitedTextField.vue";
import CharacterLimitedTextArea from "@/components/formfields/CharacterLimitedTextArea.vue";
import EmailTextField from "@/components/formfields/EmailTextField.vue";

/**
 * Directives and form components every admin root registers globally. Shared by the main app roots
 * (main.ts configureApp) and the QA component library root, so the library renders components exactly
 * as the app does and the two registrations cannot drift apart.
 */
export function installGlobalUi(app: App): void {
	app.directive("track", trackDirective);
	app.directive("test", testDirective);

	app.component("BaseTextField", BaseTextField);
	app.component("BaseSelect", BaseSelect);
	app.component("BaseAutoComplete", BaseAutoComplete);
	app.component("CharacterLimitedTextField", CharacterLimitedTextField);
	app.component("CharacterLimitedTextArea", CharacterLimitedTextArea);
	app.component("EmailTextField", EmailTextField);
}
